<div *ngIf="noticeOptions" class="gl-notice__position">
  <gl-notice
    [attr.buttonClose]="noticeOptions?.buttonClose ? true : null"
    [attr.type]="noticeOptions?.type"
    [attr.text]="noticeOptions?.text"
    [attr.icon]="noticeOptions?.icon"
    [attr.duration]="noticeOptions?.duration"
    (onClose)="toastService.clearNotice()"
  ></gl-notice>
</div>
